<template>
  <div class="index-page container">
    <n-card>
  
      <n-table :data="data" :columns="columns" :loading="$var('load')">
        <template #endedAt="{item}">
          {{ $app.date.format(item.endedAt) }}
        </template>
        <template #courses="{item}">
          <div v-for="course in item.courses" :key="course.id">
            {{ course.title }} - {{course.price}} тг
          </div>
          <div v-if="!item.courses.length">Регистрация</div>
        </template>
        <template #tools="{item}">
          <n-button icon="eye" flat round @click="$router.push({name: 'types.edit', params: { id: item.id, }})" />
        </template>
      </n-table>

    </n-card>
  </div>
</template>

<script>
export default {
  name: 'Index',
  data: () => ({
    data: [],
    columns: [
      { name: 'email', title: 'Email', },
      { name: 'fullName', title: 'Имя', },
      { name: 'phone', title: 'Телефон', },
      { name: 'courses', title: 'Курсы', },
      { name: 'endedAt', title: 'Подписка до', },
    ],
  }),
  mounted() {
    this.loadModels()
  },
  methods: {
    loadModels() {
      this.$var('load', true)
      $api.app.accounts.get().then((response) => {
        this.data = response.data.content
      }).finally(() => {
        this.$var('load', false)
      })
    },
  },
}
</script>

<style lang="scss" scoped>
  .index-page {
  
    --n-image-width: 150px;
    --n-image-height: 150px;
  }
</style>
